import { render, staticRenderFns } from "./Kkloading.vue?vue&type=template&id=c9d0ae10&"
import script from "./Kkloading.vue?vue&type=script&lang=js&"
export * from "./Kkloading.vue?vue&type=script&lang=js&"
import style0 from "./Kkloading.vue?vue&type=style&index=0&id=c9d0ae10&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports